import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import * as _ from 'underscore';
import { AjaxService } from '.././services/ajax.service';

@Injectable()
export class CountryDataService {
    countries = [];
    blockedCountries = [];
    countriesDetails: any = undefined;
    countryCallStack = [];
    ipCountry: string = "";
    currencyDetails: any = [];
    currencyCallStack = [];
    country;
    constructor(private ajaxService: AjaxService) {
    }
    set Country(ipCountry) {
        this.ipCountry = ipCountry;
    }
    get Country() {
        return this.ipCountry ? this.ipCountry : "MT";
    }
    setData(countries) {
        this.countries.push(countries);
        this. blockedCountries.push(countries);
    }

    getData() {
        return this.countries;
    }
    getCountries(type?: string) {
        if (type === 'blockedCountries') {
            return this.countries;
        }else{
            return this.blockedCountries.length > 0 ? this.blockedCountries[0].countrylist : "" ;
        }
    }
    set IPCountry(country) {
        this.country = country;
    }
    get IPCountry() {
        return this.country;
    }
    getCountriesDetails(){

        if (!_.isEmpty(this.countriesDetails)){
            return this.countriesDetails;
        }
        return new Promise((resolve, reject) => {
            if (this.countryCallStack.length > 0){
                this.countryCallStack.push(resolve);
            }else{
                this.countryCallStack.push(resolve);
                this.ajaxService.getCountries().then(data => {
                this.countriesDetails = data;
                 for (let callback in  this.countryCallStack){
                    if (callback){
                        this.countryCallStack[callback](this.countriesDetails);
                    }
                }
                this.countryCallStack = [];
              });
            }
          });
    }
    getEnabledCurrencies() {
        if (this.currencyDetails.length > 0) {
            return of(this.currencyDetails);
        }
        return new Observable((resolve) => {
            if (this.currencyCallStack.length > 0) {
                this.currencyCallStack.push(resolve);
            } else {
                this.currencyCallStack.push(resolve);
                this.ajaxService.getEnabledCurrencies().subscribe(data => {
                    this.currencyDetails = data;
                    for (let callback in this.currencyCallStack) {
                        if (callback) {
                            this.currencyCallStack[callback].next(this.currencyDetails);
                        }
                    }
                    this.currencyCallStack = [];
                });
            }
        });
    }
}
